import { Button, Popover } from "~/components/ui";
import { useState, type FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { useQuickPrompts } from "~/hooks/use-quick-prompts";
import { WandSparkles } from "lucide-react";

interface QuickPromptsPopoverButtonProps {
  onSelect: (prompt: string) => void;
}

export const QuickPromptsPopoverButton: FunctionComponent<QuickPromptsPopoverButtonProps> = ({ onSelect }) => {
  const { t } = useTranslation("chat");
  const { prompts, isLoading } = useQuickPrompts();
  const [open, setOpen] = useState(false);

  if (isLoading || !prompts.length) {
    return null;
  }

  const handleSelect = (content: string) => {
    onSelect(content);
    setOpen(false);
  };

  const popoverContent = (
    <div className="flex flex-col gap-2">
      {prompts.map(({ short, content }) => (
        <Button key={short} onClick={() => handleSelect(content)} className="rounded-2xl">
          {short}
        </Button>
      ))}
    </div>
  );

  return (
    <Popover content={popoverContent} trigger="click" open={open} onOpenChange={setOpen}>
      <Button
        icon={<WandSparkles size={14} />}
        aria-label={t("quickPromptsButtonLabel")}
        className="sm:hidden absolute right-12 bottom-2 p-0"
      />
    </Popover>
  );
};
